import React, { useState, useEffect } from "react";
import BackdropComponent from "../../components/Spinner/Spinner";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { getPiiDatabyOracleId } from "../../services/userServices";
import AsttButton from "../AsttButton/AsttButton";
import SnackBar from "components/SnackBar/SnackBar";
import applicationUsageLog from "../../utils/applicationUsagesLog";
import piiAuditLog from "../../utils/piiAuditLog";

export default function PiiReportOracleIdDisplay(props) {
  const [loading, setLoader] = useState([false]);
  const [PiiData, setPiiData] = useState([]);

  const [snack, setSnack] = useState({
    open: false,
    message: "",
    severity: "",
  });

  useEffect(() => {
    let cancelled = false;

    const fetchData = async () => {
      if (!cancelled) {
        setLoader(true);
      }

      try {
        // API call to get pii data on the basis of passed parameter oracle id.
        const piiDetails = await getPiiDatabyOracleId(props.oracleId);

        if (cancelled) return;

        let parsedPiiData = null;
        if (piiDetails.status === true) {
          parsedPiiData = JSON.parse(piiDetails["data"]);
          if (!cancelled) {
            setPiiData(parsedPiiData);
          }
        }

        if (!cancelled) {
          applicationUsageLog(
            localStorage.getItem("User"),
            localStorage.getItem("EmailId"),
            "ASTT",
            "PII Report Oracle Id Display",
          );
        }

        // ASTT-7304: PII Access Logging. Only log when PII was actually shown.
        if (!cancelled && parsedPiiData?.employee_datalist?.length > 0) {
          piiAuditLog({
            oracleIds: props.oracleId,
            userGroup: "PII_Group_FULL",
            sourceModule: "PIIReportByOracleId",
            moduleReference: props.oracleId,
            piiFieldsShown:
              "DateOfBirth,PersonalEmail,ContactNumber,StreetAddress,StreetAddress2,City,State,Country,PostalCode,Gender,SSN_or_InternationalId",
            piiFieldsMasked: "",
          });
        }
      } catch (error) {
        if (!cancelled) {
          console.error("Failed to fetch PII data:", error);
        }
      } finally {
        if (!cancelled) {
          setLoader(false);
        }
      }
    };

    fetchData();

    return () => {
      cancelled = true;
    };
  }, []);

  //Copy table data to clipboard.
  const copyToClipboard = () => {
    const piiTableData = document.getElementById("piiTable");
    navigator.clipboard.writeText(piiTableData.innerText);
    setSnack({
      open: true,
      message: "Copied!",
      severity: "success",
    });
  };

  const snackReset = () => {
    setSnack({
      open: false,
      message: "",
      severity: "",
    });
  };

  return (
    <div>
      {loading ? <BackdropComponent /> : null}
      <AsttButton onClick={copyToClipboard}>Copy data to clipboard</AsttButton>
      <TableContainer className="pii-display-container">
        <Table
          id="piiTable"
          sx={{ minWidth: 100, maxHeight: 300 }}
          aria-label="simple table"
          stickyHeader
        >
          <TableHead>
            <TableRow>
              <TableCell
                sx={{
                  whiteSpace: "nowrap",
                  position: "sticky",
                  left: 0,
                  zIndex: 300,
                }}
                align="left"
              >
                Oracle ID
              </TableCell>
              <TableCell sx={{ whiteSpace: "nowrap" }} align="left">
                Date Of Birth
              </TableCell>
              <TableCell sx={{ whiteSpace: "nowrap" }} align="left">
                Personal Email Address
              </TableCell>
              <TableCell sx={{ whiteSpace: "nowrap" }} align="left">
                Contact Number
              </TableCell>
              <TableCell sx={{ whiteSpace: "nowrap" }} align="left">
                Street Address
              </TableCell>
              <TableCell sx={{ whiteSpace: "nowrap" }} align="left">
                Street Address 2
              </TableCell>
              <TableCell sx={{ whiteSpace: "nowrap" }} align="left">
                City
              </TableCell>
              <TableCell sx={{ whiteSpace: "nowrap" }} align="left">
                State
              </TableCell>
              <TableCell sx={{ whiteSpace: "nowrap" }} align="left">
                Country
              </TableCell>
              <TableCell sx={{ whiteSpace: "nowrap" }} align="left">
                Postal Code
              </TableCell>
              <TableCell sx={{ whiteSpace: "nowrap" }} align="left">
                Gender
              </TableCell>
              <TableCell sx={{ whiteSpace: "nowrap" }} align="left">
                SSN/ International ID
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {PiiData?.employee_datalist?.map((row) => (
              <TableRow>
                <TableCell
                  sx={{
                    whiteSpace: "nowrap",
                    position: "sticky",
                    left: 0,
                  }}
                  component="th"
                  scope="row"
                  align="right"
                >
                  {row?.oracle_id}
                </TableCell>
                <TableCell sx={{ whiteSpace: "nowrap" }} align="=right">
                  {row?.personal_information?.date_of_birth}
                </TableCell>
                <TableCell sx={{ whiteSpace: "nowrap" }} align="=right">
                  {row?.personal_information?.emailaddress}
                </TableCell>
                <TableCell sx={{ whiteSpace: "nowrap" }} align="=right">
                  {row?.personal_information?.contact_number}
                </TableCell>
                <TableCell sx={{ whiteSpace: "nowrap" }} align="=right">
                  {row?.personal_information?.street_address}
                </TableCell>
                <TableCell sx={{ whiteSpace: "nowrap" }} align="=right">
                  {row?.personal_information?.street_address_2}
                </TableCell>
                <TableCell sx={{ whiteSpace: "nowrap" }} align="=right">
                  {row?.personal_information?.city}
                </TableCell>
                <TableCell sx={{ whiteSpace: "nowrap" }} align="=right">
                  {row?.personal_information?.state}
                </TableCell>
                <TableCell sx={{ whiteSpace: "nowrap" }} align="=right">
                  {row?.personal_information?.country}
                </TableCell>
                <TableCell sx={{ whiteSpace: "nowrap" }} align="=right">
                  {row?.personal_information.postal_code}
                </TableCell>
                <TableCell sx={{ whiteSpace: "nowrap" }} align="=right">
                  {
                    row?.personal_information
                      ?.gender /* Not available in the API reposnse as per 19-Sep-2022 */
                  }
                </TableCell>
                <TableCell sx={{ whiteSpace: "nowrap" }} align="=right">
                  {row?.personal_information?.ssn_or_international_id}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <SnackBar snack={snack} snackReset={snackReset}></SnackBar>
    </div>
  );
}
